import useShowError from 'hooks/useShowError'
import { useEffect, useMemo } from 'react'
import { useUpsertUserPreferenceMutation, useUserPreferencesQuery } from '../../graphql'

export enum UserPreferenceKeys {
  FilterStoreIds = 'filter.storeIds',
}

export type UserPreferenceKeyTypes = {
  [UserPreferenceKeys.FilterStoreIds]: number[],
}

export type UseUserPreferencesReturnType = {
  initialized: boolean,
  userPreferences: UserPreferenceKeyTypes,
  saveUserPreference: ( key: UserPreferenceKeys, value: any ) => Promise<void>,
}

let initialized = false

export default function useUserPreferences() {
	const showError = useShowError()
	const [ upsertUserPreferenceMutation ] = useUpsertUserPreferenceMutation()

	const { loading, data, error, refetch } = useUserPreferencesQuery( )

	useEffect( () => {
		if ( error && error.message !== 'Resource not found' ) {
			showError( `UserPreferencesQueryError${Date.now()}`, `${error.message}` )
		}
	}, [ error ] )

	useEffect( () => {
		if ( !loading && data?.userPreferences?.preferences && !initialized ) {
			initialized = true
		}
	}, [ loading, data ] )

	const userPreferences = useMemo( () => {
		if ( !loading && data?.userPreferences?.preferences ) {
			return data.userPreferences.preferences
		}
		return {}
	}, [ loading, data ] )

	return {
		initialized,
		userPreferences,
		saveUserPreference: async( key: UserPreferenceKeys, value: any ) => {
			try {
				await upsertUserPreferenceMutation( {
					variables: {
						key,
						value,
					},
				} )
				refetch()
			} catch ( e ) {
				showError( `UserPreferencesMutationError${Date.now()}`, 'Failed to save User Preferences' )
			}
		}
	} as unknown as UseUserPreferencesReturnType
}
